import type { ReferencedEntry } from 'contentful';
import React, { useState } from 'react';

import type { HasExternalSources, HasVideo } from 'api/contentful/contentTypes.cloverdotcom';
import { getField } from 'utils/EntryUtil';
import { VideoPlayer } from '@clover-growth/video-player';
import { Modal } from '../Modal/Modal';
import styles from './ExternalMediaModalLink.module.scss';

type ModalLinkProps = {
  topic?: ReferencedEntry<HasVideo & HasExternalSources>;
} & React.AllHTMLAttributes<HTMLSpanElement>;

export const ExternalMediaModalLink: React.FC<ModalLinkProps> = ({ children, topic, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  const youtubeId = getField(topic, 'youtubeId');

  if (!youtubeId) {
    return <span {...props}>{children}</span>;
  }

  return (
    <>
      <a onClick={() => setIsOpen(true)} style={{ width: '100%' }}>
        {children}
      </a>
      <Modal isOpen={isOpen} mediaOnly onRequestClose={() => setIsOpen(false)}>
        <VideoPlayer
          videoUrl={youtubeId}
          playerType="youtube"
          autoplay={false}
          className={styles.videoPlayerInModal}
          onEnded={() => setIsOpen(false)}
        />
      </Modal>
    </>
  );
};
